import styled from '@emotion/styled';
import { useRef } from 'react';
import { useButton, useFocusRing, useFocusManager, mergeProps } from 'react-aria';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { motion } from '../../../theme/motion';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';

import { getIconUrl } from './getIconUrl';

export function ResultEntry(props) {
  const ref = useRef();
  const focusManager = useFocusManager();
  const focusRing = useFocusRing({});

  function onKeyDown(event) {
    switch (event.key) {
      case 'ArrowDown':
        focusManager.focusNext({ wrap: true });
        break;
      case 'ArrowUp':
        focusManager.focusPrevious({ wrap: true });
        break;
      default:
        event.continuePropagation();
        break;
    }
  }

  const button = useButton({
    onPress: props.onPress,
    onKeyDown,
    elementType: 'a',
    //excludeFromTabOrder: true
  });
  const url = getIconUrl({ iconId: props.iconId });

  const icon =
    url ??
    (props.type === 'flow'
      ? glyph.system.flow
      : props.type === 'log'
        ? glyph.system.insights
        : null);

  // useEffect(() => {
  //   const unregister = props.registerFocusableItem(key, () => {
  //
  //   })
  //
  //   return function() {
  //     unregister();
  //   }
  //
  // }, [props.registerFocusableItem])

  return (
    <ResultEntry.Root
      {...mergeProps(button.buttonProps, focusRing.focusProps)}
      ref={ref}
      style={{
        '--background-color': focusRing.isFocusVisible && theme.color.background_hover,
      }}
    >
      <ResultEntry.IconWrapper
        style={{
          '--background-color': props.color ?? theme.color.system_flow,
        }}
      >
        <Glyph
          source={icon}
          color={theme.color.white}
          size={url != null ? theme.icon.size_default : theme.icon.size_medium}
        />
      </ResultEntry.IconWrapper>

      <ResultEntry.InfoContainer>
        <ResultEntry.Title>{props.title}</ResultEntry.Title>
        <ResultEntry.Subtitle>{props.subtitle}</ResultEntry.Subtitle>
      </ResultEntry.InfoContainer>
    </ResultEntry.Root>
  );
}

ResultEntry.IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--background-color);
  width: ${su(4)};
  height: ${su(4)};
`;

ResultEntry.InfoContainer = styled.div`
  padding-inline-start: ${su(1)};
`;

ResultEntry.Title = styled.div`
  line-height: 18px;
  color: ${theme.color.text};
`;

ResultEntry.Subtitle = styled.div`
  color: ${theme.color.text_light};
  font-size: ${theme.fontSize.small};
  line-height: 18px;
  transition: color ${motion.duration.fast} ${motion.curve.fast_in};
`;

ResultEntry.Root = styled.a`
  min-width: 500px; //force width to avoid animation shift on open
  display: flex;
  align-items: center;
  justify-content: flex-start;
  outline: 0;
  text-decoration: none;
  padding: ${su(0.5, 2)};
  cursor: pointer;
  background-color: var(--background-color, initial);
  transition: background-color ${motion.duration.fast} ${motion.curve.fast_in};

  &:hover {
    background-color: ${theme.color.background_hover};

    ${ResultEntry.Title} {
      font-weight: ${theme.fontWeight.medium};
    }

    ${ResultEntry.Subtitle} {
      color: ${theme.color.text_light_hover};
    }
  }
`;
